// Issue #32 — strip credential-bearing query params before a
// `pathname + search` value gets stashed for a post-login redirect.
//
// `/analyses/:id` is deliberately reachable without signing in (a
// share-link or audit-link recipient can view it directly), so the
// current URL can legitimately carry a bearer credential in its query
// string (`?token=...` for an audit link, `?slug=...` for a share
// link — see hooks/useAnalysisDoc.js's "slug as bearer credential"
// comment). If that recipient then clicks "Sign in", three call sites
// (UserMenu.jsx, RequireAuth.jsx, ChatDrawer.jsx) stash
// `pathname + search` into sessionStorage under "scope:post_login" so
// AuthContext.jsx's `signIn()` can restore it after the OAuth round
// trip — but `signIn()` also embeds that same value into the
// `redirect=` query param of the URL it sends to the external OAuth
// provider (auth.emergentagent.com). Left unstripped, the credential
// would land in that third party's access logs.
//
// Used at all three write sites so this can't drift between them.
export const CREDENTIAL_QUERY_PARAMS = ["token", "slug"];

export function stripCredentialParams(pathAndSearch) {
    if (typeof pathAndSearch !== "string" || !pathAndSearch) return pathAndSearch;
    const qIndex = pathAndSearch.indexOf("?");
    if (qIndex === -1) return pathAndSearch;
    const path = pathAndSearch.slice(0, qIndex);
    const params = new URLSearchParams(pathAndSearch.slice(qIndex + 1));
    for (const key of CREDENTIAL_QUERY_PARAMS) params.delete(key);
    const remaining = params.toString();
    return remaining ? `${path}?${remaining}` : path;
}

export default stripCredentialParams;
